import React, { Component } from "react";
import axios from "../../../axios";
import moment from "moment";
import FormDropdown from "../../../components/FormDropdown";
import DatePicker from "react-datepicker";
import qs from "qs";
import Alert from "react-s-alert";
import Paging from "../../../components/Paging";
import NavLink from "react-router-dom/NavLink";
import CustomModal from "../../../components/CustomModal";
import SetWaktu from "../SetWaktu";
import ModalHelp from "../../../components/ModalHelp";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { Badge, Nav } from "reactstrap";

class Lists extends Component {
  constructor() {
    super();
    this.state = {
      dataKelas: [],
      dataMapel: [],
      dataGuru: [],
      dataReport: [],
      pageCount: 0,
      currentPage: 0,
      user_id: "",
      mapel_id: "",
      dateNowStart: "",
      dateNowEnd: "",
      dateStart: moment(),
      dateEnd: moment(),
      isLoading: true,
      isButtonLoading: false,
      isModalShow: false,
      isModalSetWaktuShow: false,
      exam_id: "",
      exam_start_date: "",
      exam_title: "",
      start: "",
      tutorial: "",
      isModalHelpShow: false,
      end: "",
      sortName: "",
      sortOrder: "",
      startNo: 1,
    };

    this.handleChangeDatepickerStart = this.handleChangeDatepickerStart.bind(
      this
    );
    this.handleChangeDatepickerEnd = this.handleChangeDatepickerEnd.bind(this);
    this.handlePageClick = this.handlePageClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeStatus = this.handleChangeStatus.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.toggleModalSetWaktu = this.toggleModalSetWaktu.bind(this);
    this.handleSubmitDeleteButton = this.handleSubmitDeleteButton.bind(this);
    this.toggleModalHelp = this.toggleModalHelp.bind(this);
  }

  handleChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  toggleModalHelp() {
    this.setState({ tutorial: "https://www.youtube.com/embed/o9yaY0EwbEs" });

    this.setState({ isModalHelpShow: !this.state.isModalHelpShow });
  }

  handleChangeDatepickerStart(e) {
    this.setState(
      {
        dateStart: e,
        dateNowStart: e.format("YYYY-MM-DD"),
        isLoading: true,
      },
      () => {
        this.loadData();
      }
    );
  }

  handleChangeDatepickerEnd(e) {
    this.setState(
      {
        dateEnd: e,
        dateNowEnd: e.add(1, "days").format("YYYY-MM-DD"),
        isLoading: true,
      },
      () => {
        this.loadData();
      }
    );
  }

  toggleModal() {
    this.setState({ isModalShow: !this.state.isModalShow });
  }

  toggleModalSetWaktu() {
    this.setState({ isModalSetWaktuShow: !this.state.isModalSetWaktuShow });

    if (this.state.isModalSetWaktuShow) {
      this.loadData();
    }
  }

  handleSubmitDeleteButton() {
    this.setState({ isButtonLoading: true, modalShow: true });

    const url = "/deleteujian";

    let newState = {
      user_id: localStorage.SISMART_USER_ID,
      exam_id: this.state.exam_id,
      exam_title: this.state.exam_title,
      exam_start_date: this.state.exam_start_date,
    };

    axios({
      method: "post",
      url: url,
      data: qs.stringify(newState),
    })
      .then((response) => {
        const result = response.data;

        if (result.success) {
          Alert.success(result.message);
          this.toggleModal();
          this.loadData();
          window.location.reload();
        } else {
          if (Array.isArray(result.message)) {
            result.text.map((item) => {
              Alert.error(item);

              return true;
            });
          } else {
            Alert.error(result.message);
          }

          this.setState({ isButtonLoading: false });
        }
      })

      .catch((error) => {
        console.log(error);
        this.setState({ isButtonLoading: false });
        Alert.error("Gagal terhubung ke server!");
      });

    this.setState({ modalShow: false });
  }

  handlePageClick(data) {
    let selected = data.selected; // zero based index

    this.setState({ currentPage: selected }, () => {
      this.loadData();
    });
  }

  loadDataMapel() {
    axios
      .post("/mapel")
      .then((response) => {
        return response.data.mapelexport.map((item) => ({
          key: item.mapel_id,
          value: item.mapel_nama,
        }));
      })
      .then((result) => {
        this.setState({
          dataMapel: result,
        });
      })
      .catch((error) => {
        console.log("Mapel Undefinded");
      });
  }

  loadDataGuru() {
    axios
      .post("/user?level=guru")
      .then((response) => {
        return response.data.data.map((item) => ({
          key: item.user_id,
          value: item.user_nama,
        }));
      })
      .then((result) => {
        this.setState({
          dataGuru: result,
        });
      })
      .catch((error) => {
        console.log("Guru Undefinded");
      });
  }

  handleChangeStatus(exam_status, exam_id, user_id) {
    if (exam_status == 1) {
      exam_status = 0;
    } else {
      exam_status = 1;
    }
    let exam_status_new = exam_status;
    console.log("data status " + exam_status);
    axios
      .post(
        "/exam/update-status",
        qs.stringify({ exam_status_new, exam_id: exam_id, user_id: user_id })
      )
      .then((response) => {
        const res = response.data;
        if (res.status) {
          Alert.success(res.text);
          this.loadData();
        } else {
          Alert.warning(res.text);
        }
      })
      .catch((error) => {
        console.log(error);
        Alert.error("Gagal terhubung ke server!");
      });
  }

  loadData() {
    this.setState({ isLoading: true, isButtonLoading: true });

    const params = qs.stringify({
      page: this.state.currentPage + 1,
      mapel: this.state.mapel_id,
      user: this.state.user_id,
      tglMulai: this.state.dateNowStart,
      tglEnd: this.state.dateNowEnd,
      sortName: this.state.sortName,
      sortOrder: this.state.sortOrder,
    });

    axios
      .post("/ujian?" + params)

      .then((response) => {
        const result = response.data;
        if (result.success === true) {
          this.setState({
            dataReport: result.data.data,
            pageCount: result.data.last_page,
            isLoading: false,
            isButtonLoading: false,
            startNo: result.data.from,
            sortName: this.state.sortName,
            sortOrder: this.state.sortOrder,
          });
        } else {
          Alert.error(result.message);
          this.setState({ isLoading: false });
        }
      })

      .catch((error) => {
        this.setState({ isLoading: false });
        Alert.error("Gagal terhubung ke server!");
      });
  }

  componentDidMount() {
    if (localStorage.SISMART_USER_LEVEL !== "administrator") {
      this.props.history.replace("/dashboard");
    }
    this.loadDataMapel();
    this.loadDataGuru();
    this.loadData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.mapel_id !== this.state.mapel_id ||
      prevState.user_id !== this.state.user_id ||
      prevState.sortName !== this.state.sortName ||
      prevState.sortOrder !== this.state.sortOrder
    ) {
      this.loadData();
    }
  }

  onSortChange(sortName, sortOrder) {
    this.setState({
      sortName,
      sortOrder,
    });
  }

  formatOpsi(cell, row, enumObject, index) {
    let isA = moment().isAfter(moment(row.exam_start_date));
    let isD = moment().isAfter(moment(row.exam_start_date));
    const url = this.props.match.url;

    return (
        <div>
          <button
              type="button"
              className="btn btn-danger btn-sm"
              title="Hapus"
              onClick={() => {
                this.toggleModal();
                this.setState({
                  exam_id: row.exam_id,
                  exam_title: row.exam_title,
                  exam_start_date: row.exam_start_date,
                });
              }}
          >
            <i className="fa fa-trash"></i>
          </button>{" "}
          <NavLink
              to={`${url}/edit/${row.exam_id}`}
              className="btn btn-secondary btn-sm"
          >
            <i className="fa fa-pencil" title="Edit"></i>{" "}
          </NavLink>{" "}
          <button
              type="button"
              className="btn btn-danger btn-sm"
              title="Set Tambahan Waktu"
              onClick={() => {
                this.toggleModalSetWaktu();
                this.setState({
                  exam_id: row.exam_id,
                  startOld: row.exam_start_date,
                  endOld: row.exam_end_date,
                });
              }}
          >
            <i className="fa fa-clock-o"></i>
          </button>
          <div style={{ marginTop: "5px" }}></div>
          {row.status === "1" ? (
              <div></div>
          ) : isA == true ? (
              isD == true ? (
                  <div>
                    <NavLink
                        to={`${url}/soal/${row.mapel_id}/${row.exam_id}`}
                        className="btn btn-secondary btn-sm"
                        style={{ margin: 5 }}
                    >
                      Soal
                    </NavLink>
                    <button className="btn btn-info btn-sm">Ujian Selesai </button>
                  </div>
              ) : (
                  <button className="btn btn-danger btn-sm">Ujian Berjalan </button>
              )
          ) : (
              <div>
                <NavLink
                    to={`${url}/soal/${row.mapel_id}/${row.exam_id}`}
                    className="btn btn-secondary btn-sm"
                >
                  Soal
                </NavLink>{" "}
                <NavLink
                    to={`${url}/edit/${row.exam_id}`}
                    className="btn btn-secondary btn-sm"
                >
                  Edit{" "}
                </NavLink>
              </div>
          )}
        </div>
    );
  }

  formatStatus(cell, row, enumObject, index) {
    const url = this.props.match.url;
    return (
        <div>
          <button
              type="button"
              className={`btn ${
                  row.exam_status === "1" ? "btn-primary" : "btn-danger"
              }`}
              title={
                row.exam_status === "1"
                    ? "Non Aktifkan Ujian Ini"
                    : "Aktifkan Ujian Ini"
              }
              onClick={() => {
                this.handleChangeStatus(
                    row.exam_status,
                    row.exam_id,
                    row.user_id
                );
              }}
          >
            {row.exam_status === "1" ? "Set Aktif" : "Set Non Aktif"}
          </button>{" "}
          <br />
          <NavLink
              to={`${url}/remed/${row.exam_id}`}
              className="btn btn-secondary"
              style={{ marginTop: 5 }}
              title="Buat Remedial"
          >
            <i className="fa fa-recycle"></i>
          </NavLink>{" "}
          <NavLink
              to={`${url}/remed/${row.exam_id}/siswa`}
              className="btn btn-primary"
              style={{ marginTop: 5 }}
              title="Siswa"
          >
            <i className="fa fa-user"></i>
          </NavLink>{" "}
          <NavLink
              to={`${url}/wb/${row.exam_id}/siswa`}
              className="btn btn-primary"
              style={{ marginTop: 5 }}
              title="Siswa Ujian di Web Browser"
          >
            <i className="fa fa-globe"></i>
          </NavLink>{" "}
        </div>
    );
  }

  render() {
    const strt = this.state.startNo;
    const url = this.props.match.url;

    function indexN(cell, row, enumObject, index) {
      return <div>{index + strt}</div>;
    }

    function formatCat(cell, row, enumObject, index) {
      return (
        <div>
          {row.exam_cat_type != null ? row.exam_cat_type.toUpperCase() : "-"}
          <br />
          {row.exam_id}
          <br />
          <span
            className="badge badge-primary"
            title="Nilai ditampilkan setelah selesai mengerjakan ujian"
          >
            {row.exam_show_score === "1" ? "Nilai" : ""}
          </span>
          <br />
          <span
            className="badge badge-danger"
            title="Jawaban ditampilkan setelah selesai mengerjakan ujian"
          >
            {row.exam_show_result === "1" ? "Jawaban" : ""}
          </span>
        </div>
      );
    }

    function formatDate(cell, row, enumObject, index) {
      return (
        "Mulai : " +
        moment(row.exam_start_date).format("D/M/YYYY H:mm") +
        "<br/>Selesai : " +
        moment(row.exam_end_date).format("D/M/YYYY H:mm")
      );
    }

    function formatNama(cell, row, enumObject, index) {
      return (
        <div>
          {row.exam_title}
          <div style={{ marginTop: "10px" }}>
            <Badge color={"primary"} style={{ padding: "5px" }}>
              {row.user_nama}
            </Badge>
            <br />
            <Badge color={"primary"} style={{ padding: "5px" }}>
              {row.mapel_nama}
            </Badge>
          </div>
        </div>
      );
    }

    const options = {
      clearSearch: true,
      searchPosition: "left",
      sortName: this.state.sortName,
      sortOrder: this.state.sortOrder,
      onSortChange: this.onSortChange.bind(this),
    };

    return (
      <div className="col-sm-12">
        <CustomModal
          isShow={this.state.isModalShow}
          toggleModal={this.toggleModal}
          handleSubmit={this.handleSubmitDeleteButton}
          modalHeaderText="Hapus Data"
          modalBodyText="Anda yakin ingin menghapus data ini?"
          modalSubmitText="Ya"
        />
        <SetWaktu
          isShow={this.state.isModalSetWaktuShow}
          toggleModal={this.toggleModalSetWaktu}
          handleSubmit={this.handleSubmitSetWaktu}
          examId={this.state.exam_id}
          startOld={this.state.startOld}
          endOld={this.state.endOld}
          modalHeaderText="Tambah Waktu Ujian"
          modalBodyText="Anda yakin ingin menghapus data ini?"
          modalSubmitText="Ubah"
        />

        <ModalHelp
          isShow={this.state.isModalHelpShow}
          toggleModal={this.toggleModalHelp}
          handleSubmit={this.handleSubmitDeleteButton}
          modalHeaderText="Tutorial Penggunaan Fitur"
          modalBodyText={this.state.tutorial}
          modalSubmitText="Ya"
        />

        <div className="card">
          <div className="card-header">
            Ujian dan Tugas
            <button
              type="button"
              title="Tutorial"
              className="btn btn-danger btn-sm"
              style={{ float: "right" }}
              onClick={() => {
                this.toggleModalHelp();
                // this.setState({ tutorial: levelName});
              }}
            >
              <i className="fa fa-question-circle" s></i>
            </button>
          </div>
          <div className="card-block">
            <div className="form-group row">
              <div className="col-md-2">
                <FormDropdown
                  items={this.state.dataGuru}
                  onChange={this.handleChange}
                  value={this.state.user_id.toString()}
                  placeholder={"Pilih Guru"}
                  name="user_id"
                />
              </div>

              <div className="col-md-2">
                <FormDropdown
                  items={this.state.dataMapel}
                  onChange={this.handleChange}
                  value={this.state.mapel_id.toString()}
                  placeholder={"Pilih Mapel"}
                  name="mapel_id"
                />
              </div>

              <div className="col-md-2">
                {
                  <DatePicker
                    selected={this.state.dateStart}
                    onChange={this.handleChangeDatepickerStart}
                    showYearDropdown
                    scrollableYearDropdown
                    yearDropdownItemNumber={15}
                  />
                }
              </div>

              <div className="col-md-2">
                {
                  <DatePicker
                    selected={this.state.dateEnd}
                    onChange={this.handleChangeDatepickerEnd}
                    showYearDropdown
                    scrollableYearDropdown
                    yearDropdownItemNumber={15}
                  />
                }
              </div>

              <div className="col-md-2">
                <NavLink
                  to={`${this.props.match.url}/add`}
                  className="btn btn-primary"
                  style={{ float: "right" }}
                >
                  Tambah Data Baru
                </NavLink>
              </div>

              {/* <div className="col-md-2">
                               <button
                                   className="btn btn-primary"
                                   disabled={this.state.isButtonLoading && "disabled" || this.state.dataReport.length === 0 && "disabled"}
                                   onClick={this.exportFile}>
                                   {this.state.isButtonLoading || this.state.dataReport.length === 0 ? "Menyiapkan file..." : "Export Presensi"}
                               </button>
                           </div>*/}
            </div>
            <hr />
            {this.state.isLoading ? (
              "Memuat Data..."
            ) : this.state.dataReport.length === 0 ? (
              "Data tidak ditemukan..."
            ) : (
              <div>
                <BootstrapTable
                  data={this.state.dataReport}
                  striped
                  hover
                  remote
                  options={options}
                >
                  <TableHeaderColumn
                    width="50"
                    dataField="any"
                    dataFormat={indexN}
                    isKey
                  >
                    No
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    width="70"
                    dataField="exam_cat_type"
                    dataSort
                    dataFormat={formatCat}
                  >
                    Type
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    width="200"
                    dataField="exam_title"
                    dataSort
                    dataFormat={formatNama}
                  >
                    Judul
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    width="200"
                    dataField="exam_end_date"
                    dataSort
                    dataFormat={formatDate}
                  >
                    Mulai-Berakhir
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    width="150"
                    dataField="exam_cat_status"
                    dataFormat={this.formatStatus.bind(this)}
                  >
                    Status
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    width="150"
                    dataField="any"
                    dataFormat={this.formatOpsi.bind(this)}
                  >
                    Opsi
                  </TableHeaderColumn>
                </BootstrapTable>
                <hr />

                <Paging
                  handlePageClick={this.handlePageClick}
                  pageCount={this.state.pageCount}
                  currentPage={this.state.currentPage}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default Lists;



// WEBPACK FOOTER //
// ./src/views/Exam/Schedule/Lists.js